
import { useState } from "react";

import { Box, Tab, Tabs } from "@mui/material";

import { Layout } from "../../components/Layout"

import { CalendarPage } from "./CalendarPage";
import { AudienciasCanceladasPage } from "./AudienciasCanceladasPage";
import { AsignarSalaPage } from "./AsignarSalaPage";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel( props: TabPanelProps ) {

    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={ value !== index }
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            { ...other }
        >
            { value === index && <Box sx={{ p: 3 }}> { children } </Box> }
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const AudienciasPage = () => {

    const [value, setValue] = useState(0);

    const handleChange = ( _: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (

        <Layout breadcrumbs={[{ text: 'Gestionar audiencia(s)' }]}>     

            <Box sx={{ width: '100%' }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        
                        <Tab label="Agendar audiencia" { ...a11yProps(0) } />
                        <Tab label="Audiencia(s) cancelada(s)" { ...a11yProps(1) } />
                        <Tab label="Asignar sala" { ...a11yProps(1) } />

                    </Tabs>

                </Box>

                <CustomTabPanel value={value} index={0}>
                    
                    <CalendarPage />                    

                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                    
                    <AudienciasCanceladasPage />

                </CustomTabPanel>     

                <CustomTabPanel value={value} index={2}>
                    
                    <AsignarSalaPage />

                </CustomTabPanel>                

            </Box>    

        </Layout>
    )
}
